// NATIVE 


// INSTALLED 
import { Alert, Button, Grid } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import Inventory2Icon from '@mui/icons-material/Inventory2';


// CUSTOM 
import { storeItemsStore } from 'store/size_items';
import { DinamicDotacion } from './dinamic-dotacion/DinamicDotacion';





export const Dotacion = (props:any) => {


    // DISPATCH  
    const dispatch = useDispatch();
  
    // REDUX 
    const { sizeItemsDotacion }: any = useSelector((state: any) => state.sizeItems);
    

    const addItem = async() => {
  
      // Copia el último elemento del array
      const lastMember = sizeItemsDotacion[sizeItemsDotacion.length - 1];
  
      // Crea un nuevo array con el nuevo elemento al final
      const newArray = [...sizeItemsDotacion, { ...lastMember }];
  
      // Despacha la acción para actualizar el store (ajusta el action según tu implementación)
      await dispatch( storeItemsStore(newArray) );
  
    }



  return (
    <div>


      <Grid size={{ xs: 3 }}> 
        <Button
          variant="contained"
          color="primary"
          startIcon={<AddCircleIcon />}
          endIcon={<Inventory2Icon />}
          onClick={addItem} // esta es tu función para agregar un beneficiario
          sx={{ mt: 2, borderRadius: 2 }}
        >
          Agregar Item
        </Button>
      </Grid>


      <DinamicDotacion children={sizeItemsDotacion} />


    </div>
  )
}
